import * as React from 'react'
import Alert from './AlertModal'
import { AlertButton } from './AlertStyles'

const ErrorIcon = require('./icon-error.svg')

const ErrorModal = props => (
  <Alert>
    <img src={ErrorIcon} className="alert-icon" alt="" />
    <h2>ERROR</h2>
    <h4>
      {props.children.includes('Network')
        ? 'There seems to be some connection issues, try refreshing the page?'
        : props.children}
    </h4>
    <div className="button-wrapper">
      <AlertButton color="gray" onClick={props.onDismiss}>
        DISMISS
      </AlertButton>
    </div>
  </Alert>
)

export default ErrorModal



// WEBPACK FOOTER //
// ./src/Components/Shared/Alerts/Error.tsx